/**
 * className helper.
 *
 * p3-web uses clsx + tailwind-merge. This surface is authored in plain CSS
 * with a namespaced `e-` component layer (src/app/styles/base.css), not
 * Tailwind, so there are no conflicting utility classes to merge and no
 * reason to take the dependency. Same call shape as clsx, so anything ported
 * from p3-web keeps working unchanged.
 *
 *   cn("e-card", isKpi && "is-kpi", { "span-2": wide }, extra)
 */

export type ClassValue =
  | string
  | number
  | null
  | undefined
  | false
  | ClassValue[]
  | { [key: string]: boolean | null | undefined };

export function cn(...inputs: ClassValue[]): string {
  const out: string[] = [];
  for (const input of inputs) push(out, input);
  return out.join(" ");
}

function push(out: string[], input: ClassValue): void {
  if (!input) return;
  if (typeof input === "string") {
    if (input.trim()) out.push(input.trim());
    return;
  }
  if (typeof input === "number") {
    out.push(String(input));
    return;
  }
  if (Array.isArray(input)) {
    for (const item of input) push(out, item);
    return;
  }
  for (const key of Object.keys(input)) {
    if (input[key]) out.push(key);
  }
}
